import { Link } from "react-router-dom";
import { Lock, Target, Zap, ArrowRight } from "lucide-react";
import { Reveal, Overline } from "../components/Reveal";
import { CONTACT } from "../data/content";

export const PrivateTrainingSpotlight = () => (
  <section id="private-training" className="py-24 sm:py-32 scroll-mt-16 relative overflow-hidden" data-testid="private-spotlight-section">
    <div className="absolute inset-0 opacity-[0.03]" style={{ backgroundImage: "radial-gradient(circle at 70% 30%, #D4AF37 0%, transparent 55%)" }} />
    <div className="max-w-7xl mx-auto px-6 lg:px-12 relative">
      <div className="grid lg:grid-cols-[1fr_1.2fr] gap-10 lg:gap-16 items-start">
        <Reveal>
          <p className="text-[10px] tracking-[0.28em] uppercase text-[#D4AF37] font-bold flex items-center gap-2">
            <Lock size={12} /> Application-Only · Premium
          </p>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-black uppercase tracking-tight mt-4 leading-[1.05]">
            Private <span className="text-[#D4AF37]">Training.</span>
          </h2>
          <p className="mt-5 text-white/70 text-[15px] leading-relaxed">
            Structured individual development for the players who want more than group training can offer. Selectively taken. Higher investment. Built around a single question — <span className="text-white font-semibold">what does this player need next to grow into the life of a pro footballer?</span>
          </p>
          <Link to="/private-training" data-testid="private-explore"
            className="mt-8 inline-flex items-center gap-2 border border-[#D4AF37] text-[#D4AF37] font-bold uppercase tracking-widest text-xs px-5 py-3 hover:bg-[#D4AF37] hover:text-black transition-colors duration-200">
            Explore Private Training <ArrowRight size={13} />
          </Link>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="grid sm:grid-cols-2 gap-4">
            {[
              { icon: Target, title: "Position-Specific Mastery", text: "Training precision-engineered around each player's role, gaps and technical needs." },
              { icon: Zap, title: "Accelerated Growth", text: "Small-group / 1-on-1 masterclasses that fast-track technical and tactical progress." },
              { icon: Lock, title: "Selective Acceptance", text: "Not everyone is accepted. Reserved for players committed to elite personal development." },
              { icon: Target, title: "Path to Pro Habits", text: "Building the daily routines, discipline and mindset of a modern professional." },
            ].map((c, i) => (
              <div key={c.title} className="border border-white/10 bg-[#050505] p-5 hover:border-[#D4AF37]/40 transition-colors duration-300" data-testid={`private-card-${i}`}>
                <c.icon size={18} className="text-[#D4AF37]" />
                <p className="font-heading text-base font-black uppercase tracking-tight mt-3">{c.title}</p>
                <p className="text-white/55 text-xs mt-2 leading-relaxed">{c.text}</p>
              </div>
            ))}
          </div>
          <a href={CONTACT.whatsappPrivate} target="_blank" rel="noreferrer"
            className="mt-6 inline-block text-white/60 text-xs uppercase tracking-widest hover:text-[#D4AF37]" data-testid="private-whatsapp">
            Enquire about eligibility →
          </a>
        </Reveal>
      </div>
    </div>
  </section>
);
